module.exports = __webpack_public_path__ + "static/img/samajuri (23).8e43e51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (23).jpg
// module id = i+AB
// module chunks = 0